import metrics from './metrics';
import withMetrics from './with-metrics';
import MetricsRoute from './MetricsRoute';

export * from './handlers';

export { MetricsRoute, withMetrics };

export default metrics;
